import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {AuthenticationService} from "../../services/authentication.service";
import {ToastService} from "../../core/notifications/toast-service";
import {environment} from "../../../environments/environment";
import {getErrorMessage} from "../../core/utils";

@Component({
  selector: 'app-google-link',
  standalone: true,
  imports: [],
  templateUrl: './google-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './google-link.component.scss'
})
export class GoogleLinkComponent {
  constructor(private route: ActivatedRoute,
              private httpClient: HttpClient,
              private authService: AuthenticationService,
              private router: Router,
              private toastService: ToastService) {

  }

  ngOnInit() {
    this.authService.refreshUserState().then(
      () => {
        this.route.queryParams.subscribe(params => {
          const code = params['code'];
          const state = params['state'];

          let queryParameters = new HttpParams();
          queryParameters = queryParameters.append("code", code);
          queryParameters = queryParameters.append("state", state); // TODO random state and remember state to check
          this.httpClient.get(environment.apiUrl + "oauth/google/redirect", {
            params: queryParameters
          })
            .subscribe({
              next: (value) => {
                this.toastService.showSuccess("Youtube Account erfolgreich verbunden!");
                this.toastService.showSuccess("Bitte neu einloggen");
                this.authService.signOut();
              },
              error: (err: HttpErrorResponse) => {
                this.toastService.showDanger("Youtube Account konnte nicht verbunden werden: " + getErrorMessage(err.error.errorCode));
                this.router.navigate(['/home/user'])
              },
            });
        });
      }
    )
  }
}
